import { Building2, Users, Lock } from "lucide-react";

export const VIS_FIREMNI = "firemni";
export const VIS_TYMOVY = "tymovy";
export const VIS_SOUKROMY = "soukromy";

export const VISIBILITY_META = {
    firemni: { label: "Firemní", short: "Firemní", icon: Building2, cls: "bg-slate-900 text-white border-slate-900", hint: "Jen vlastník a administrátor" },
    tymovy: { label: "Týmový", short: "Týmový", icon: Users, cls: "bg-orange-100 text-orange-800 border-orange-300", hint: "Vidí celý tým" },
    soukromy: { label: "Soukromý", short: "Soukromý", icon: Lock, cls: "bg-sky-100 text-sky-800 border-sky-300", hint: "Jen autor a přiřazený" },
};

export function VisibilityBadge({ visibility, className = "", testid }) {
    const m = VISIBILITY_META[visibility] || VISIBILITY_META.tymovy;
    const Icon = m.icon;
    return (
        <span data-testid={testid || `visibility-badge-${visibility}`} title={m.hint}
              className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 border rounded-sm ${m.cls} ${className}`}>
            <Icon className="w-3 h-3" /> {m.short}
        </span>
    );
}
